import { Row, TrackerStat } from "@/components";

import { JobTrackerResponse } from "@/types";

export const JobTrackerStats = ({ jobs }: { jobs: JobTrackerResponse[] }) => {
  // Deduplicate by jobId to avoid double-counting revenue when grouped by owner
  // (the same job appears in multiple owner groups)
  const seenJobIds = new Set<string>();
  const revenueInPlay = jobs.reduce((sum, job) => {
    if (seenJobIds.has(job.jobId)) return sum;
    seenJobIds.add(job.jobId);
    return sum + job.outstandingRevenue;
  }, 0);

  const totalReqsCount = jobs.reduce((sum, job) => {
    const perJobTotal = Object.values(job.countsByRequisitionStatus).reduce(
      (innerSum, c) => innerSum + c,
      0,
    );
    return sum + perJobTotal;
  }, 0);

  const totalJobs = jobs.length;

  const totalCompanies = new Set(jobs.map((job) => job.company.id)).size;

  const render = () => {
    return (
      <Row className="gap-2">
        <TrackerStat
          label="Revenue in play"
          value={`$${revenueInPlay.toLocaleString(undefined, { maximumFractionDigits: 2 })}`}
        />
        <TrackerStat label="Total reqs" value={totalReqsCount} />
        <TrackerStat label="Total jobs" value={totalJobs} />
        <TrackerStat label="Total companies" value={totalCompanies} />
      </Row>
    );
  };

  return render();
};
